import { inject, Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Contact, IResponse, IResponsePaginate, ContactDto } from '@/types';
import { Observable } from 'rxjs';

interface ContactQuery {
  search?: string;
  nom?: string;
  address?: string;
  tel1?: string;
  tel2?: string;
  email?: string;
  deleted?: boolean;
  page?: number;
  size?: number;
  sort?: string;
}

@Injectable({
  providedIn: 'root',
})
export class ContactService {
  BASEURL = `${environment.api.paramsUrl}/contact`;
  httpClient = inject(HttpClient);

  getContacts(params?: ContactQuery): Observable<IResponsePaginate<Contact>> {
    return this.httpClient.get<IResponsePaginate<Contact>>(`${this.BASEURL}`, { params: params as any });
  }

  getOneContact(id: number): Observable<IResponse<Contact>> {
    return this.httpClient.get<IResponse<Contact>>(`${this.BASEURL}/${id}`);
  }

  addContact(contact: ContactDto): Observable<IResponse<Contact>> {
    return this.httpClient.post<IResponse<Contact>>(`${this.BASEURL}`, contact);
  }

  updateContact(id: number, contact: ContactDto): Observable<IResponse<Contact>> {
    return this.httpClient.put<IResponse<Contact>>(`${this.BASEURL}/${id}`, contact);
  }

  deleteContact(id: number): Observable<IResponse<Contact>> {
    return this.httpClient.delete<IResponse<Contact>>(`${this.BASEURL}/${id}`);
  }
}
